/* eslint-disable no-unneeded-ternary */
import { ChangeEvent } from "react";
import { CSSProperties } from "styled-components";

import SelectOption from "../model/SelectOption";
import AutocompleteStyles from "../styles/components/AutocompleteStyles";

type Option = string | Record<string, any>;

interface AutoCompleteCleanProps {
    label?: string;
    defaultSelected?: SelectOption[];
    options: Option[];
    placeholder?: string;
    selected?: Option[] | undefined;
    extraOptions?: boolean;
    extraLabel?: string;
    disabled?: boolean;
    key?: any;
    style?: CSSProperties | string;
    id?: any;
    readOnly?: boolean;
    onChange?: ((selected: Option[]) => void) | undefined;
    onInputChange?:
        | ((text: string, event: ChangeEvent<HTMLInputElement>) => void)
        | undefined;
}

function AutoCompleteClean({
    label,
    defaultSelected,
    options,
    placeholder,
    selected,
    extraOptions,
    extraLabel,
    disabled,
    style,
    id,
    key,
    readOnly,
    onChange,
    onInputChange,
}: AutoCompleteCleanProps) {
    const { StyledLabel, StyledFormSelectClean, StyledFormGroup } =
        AutocompleteStyles;

    const styleGroup: CSSProperties = {
        width: "100%",
        marginBottom: "24px",
    };

    const filterByFields = ["value", "label"];
    return (
        <StyledFormGroup style={style || styleGroup}>
            {label ? <StyledLabel>{label}</StyledLabel> : null}
            <StyledFormSelectClean
                id={id ?? "Id padrão"}
                onChange={onChange}
                onInputChange={onInputChange}
                defaultSelected={defaultSelected}
                options={options}
                placeholder={placeholder}
                selected={selected}
                key={key}
                clearButton
                disabled={disabled}
                paginationText="Mais resultados"
                emptyLabel="Nenhum resultado encontrado"
                labelKey={(option: any) => `${option?.label}`}
                filterBy={filterByFields}
                inputProps={{
                    readOnly: readOnly ?? false,
                }}
                renderMenuItemChildren={(option: any) => (
                    <div>
                        {option?.label}
                        {extraOptions ? (
                            <div>
                                <small>
                                    {extraLabel}: {option.value}
                                </small>
                            </div>
                        ) : null}
                    </div>
                )}
            />
        </StyledFormGroup>
    );
}

export default AutoCompleteClean;
